import { useRef, useState } from "react"
import { isEircode, isUkPostcode } from "../../shared/stringUtils"

export function usePostcodeLookup() {
  const [suggestions, setSuggestions] = useState<IPostcoderSuggestion[]>([])
  const [status, setStatus] = useState<"success" | "invalid" | "notFound" | "empty" | null>(null)
  const { current: postcodeCache } = useRef({} as Record<string, IPostcoderSuggestion[]>)

  function standardizePostcode(value: string) {
    return value.toUpperCase().replace(/\s/g, "")
  }

  async function searchPostcode(value: string): Promise<any[] | boolean> {
    if (!value) {
      setStatus("empty")
      return false
    }

    const response = await loadPostcoderSuggestions(value)
    postcodeCache[standardizePostcode(value)] = response

    setStatus(response.length === 0 ? "notFound" : "success")
    setSuggestions(response)

    return response
  }

  async function loadPostcoderSuggestions(postcode: string) {
    const code = standardizePostcode(postcode)
    if (code in postcodeCache) {
      return postcodeCache[code]
    }
    return await window.api.searchPostcodes({ query: postcode })
  }

  async function getOption(option: IPostcoderSuggestion) {
    const data = await window.api.getPostcode({
      id: option.id,
      query: option.query,
      country: option.countryCode,
    })
    return { data }
  }

  function validPostcode(value: string) {
    return value && (isUkPostcode(value) || isEircode(value))
  }

  function clear() {
    setSuggestions([])
  }

  return {
    searchPostcode,
    suggestions: suggestions,
    getOption,
    status,
    clear,
    validPostcode,
  }
}

export interface IPostcoderSuggestion {
  id: string //"17330981"
  type: string //"ADD"
  summaryline: string // "41 Lefroy Road"
  locationsummary: string // "Norwich, Norfolk, NR3 2NX"
  count: number
  query: string
  countryCode: string
}
